import React, { useState, useEffect } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Heading } from '@/components/ui/typography';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Stack } from '@/components/ui/layout';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';

function Skills({ onUpdate, existingSkills = [] }) {
  const [skills, setSkills] = useState(existingSkills || []);


  useEffect(() => {
    onUpdate(skills);
  }, [skills]);

  const handleChange = (index, field, value) => {
    const updatedSkills = [...skills];
    updatedSkills[index][field] = value;
    setSkills(updatedSkills);
  };

  const addSkill = () => {
    setSkills([...skills, { name: '', level: '' }]);
  };

  const deleteSkill = (index) => {
    const updatedSkills = skills.filter((_, i) => i !== index);
    setSkills(updatedSkills);
  };

  return (
    <Card className="mb-6 bg-white">
      <CardContent className="p-4">
        <Heading level="h2" className="text-base font-semibold mb-3">
          Skills
          <span className="text-destructive ml-1">*</span>
        </Heading>
        <Stack spacing="md">
          {skills.map((skill, index) => (
            <div key={index} className={cn("space-y-4 p-4 border rounded-lg")}>
              <div className={cn("grid grid-cols-2 gap-4")}>
                <div>
                  <Label htmlFor={`skillName${index}`} className="text-sm font-medium mb-1.5">Skill</Label>
                  <Input
                    type="text"
                    id={`skillName${index}`}
                    placeholder="Enter a skill"
                    value={skill.name}
                    onChange={(e) => handleChange(index, 'name', e.target.value)}
                    className="mt-1"
                  />
                </div>
                <div>
                  <Label htmlFor={`skillLevel${index}`} className="text-sm font-medium mb-1.5">Skill Level</Label>
                  <Select
                    value={skill.level}
                    onValueChange={(value) => handleChange(index, 'level', value)}
                  >
                    <SelectTrigger className="mt-1">
                      <SelectValue placeholder="Select level" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="Beginner">Beginner</SelectItem>
                      <SelectItem value="Intermediate">Intermediate</SelectItem>
                      <SelectItem value="Advanced">Advanced</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
              </div>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => deleteSkill(index)}
                className="text-destructive self-end"
              >
                <X className="w-4 h-4 mr-2" />
                Delete Skill
              </Button>
            </div>
          ))}
          <Button variant="outline" onClick={addSkill} className="w-full">
            Add Skill
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
}

export default Skills;